import Tables from 'src/class/Tables';
import i18n from 'src/i18n';


const configTable = () => {
  const Table = { ...Tables.Table };
  Table.tableColumns = [
    {
      prop: 'observation',
      label: i18n.t('irrigation.irrigation_observation'),
      minWidth: 150,
    },
  ];

  return { Table };
};

export default configTable;


